const USER_SETTINGS_MAIN_NAV_BAR_ITEMS = [
  {
    name: "Change Password",
    routeName: "change-password"
  }
];

export default USER_SETTINGS_MAIN_NAV_BAR_ITEMS;
